import { MutationTree } from "vuex";
import { ActivityState } from "./types";
import { Activity } from "@dcc/types/activity";
import { ActivityCategory } from "@dcc/types/activityCategory";

export const mutationNames = {
  TOGGLEACTIVITY: "Toggle Activity",
  FETCHACTIVITIES: "Fetch Activities"
};

export const mutations: MutationTree<ActivityState> = {
  [mutationNames.TOGGLEACTIVITY](state, payload: string) {
    state.selected = state.selected.includes(payload)
      ? state.selected.filter((act) => act !== payload)
      : [...state.selected, payload];
  },
  [mutationNames.FETCHACTIVITIES](state, activites: Activity[]) {
    state["Active Days"] = activites.filter(
      (a) => a.category === ActivityCategory.ActiveDays
    );
    state["Easy Tips"] = activites.filter(
      (a) => a.category === ActivityCategory.EasyTips
    );
    state["Health"] = activites.filter(
      (a) => a.category === ActivityCategory.Health
    );
  }
};
